module.exports = __webpack_public_path__ + "fonts/montserrat-semibold-webfont.895249a.woff2";